import { ISearchColumn } from "../../components/modalWindows/SearchModalWindowAntd/SearchModalWindowAntd";

// Объявляем и экспортируем карту
const kizMarkDisposalStateMap: Record<string, string> = {
    'нет киз': 'noKizs',
    'выбыт': 'allDisposed',
    'не выбыт': 'noneDisposed',
    'выбыт частично': 'partialDisposed',
    'идёт отправка': 'inProgressDisposal',
    'не отработан': 'unprocDisposal'
};

type KnownConverters = 'kizMarkDisposalState';
export type ConverterType = KnownConverters | (string & {}); // string & {} для автодополнения

// Реестр конвертеров значений колонок
// добавлять новое значение по мере необходимости
const converters = {
    kizMarkDisposalState: (value: string): string => {
        return kizMarkDisposalStateMap[value.toLowerCase().trim()] || value;
    },
};

// Кэшируем обратные карты
const cachedReverseMaps = new Map<keyof typeof converters, Record<string, string>>();

function getReverseMap(converterKey: keyof typeof converters): Record<string, string> {
    if (!cachedReverseMaps.has(converterKey)) {
        const directMap = converterKey === 'kizMarkDisposalState' ? kizMarkDisposalStateMap : null;
        if (!directMap) {
            return {};
        }
        const reverseMap: Record<string, string> = {};
        for (const [original, converted] of Object.entries(directMap)) {
            reverseMap[converted.toLowerCase()] = original; // Приводим к нижнему регистру для поиска
        }
        cachedReverseMaps.set(converterKey, reverseMap);
    }
    return cachedReverseMaps.get(converterKey)!;
}


export const applyConversion = (column: IGridColumn | ISearchColumn, value: any): any => {
    if (column.conversion && converters[column.conversion]) {
        return converters[column.conversion](String(value));
    }
    return value;
}

export const applyConversionWithType = (conversion: ConverterType, value: any): any => {
    if (converters[conversion]) {
        return converters[conversion](String(value).toLocaleLowerCase().trim());
    }
    return value;
}

/**
 * Обратное преобразование значения с помощью указанного конвертера.
 * @param conversion Тип конвертера
 * @param convertedValue Значение, которое нужно преобразовать обратно
 * @returns Оригинальное значение или переданное, если не найдено соответствие
 */
export const reverseConversionWithType = (conversion: ConverterType, convertedValue: any, capitalizeFirstLetter: boolean = false): any => {
    const converterKey = conversion as keyof typeof converters;
    if (!converters[converterKey]) {
        return convertedValue;
    }

    const reverseMap = getReverseMap(converterKey);
    const originalValue = reverseMap[String(convertedValue).toLowerCase()] || convertedValue;

    if (capitalizeFirstLetter && typeof originalValue === 'string' && originalValue.length > 0) {
        return originalValue.charAt(0).toUpperCase() + originalValue.slice(1);
    }

    return originalValue;
};
